import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-isomorphic-render';
import settingsNav from 'app/containers/settings/settings-nav';

import './settings-left-nav.less';

const SETTINGS_UNRESTRICTED_NAV_LINKS = [
  { text: 'General', path: '/settings/general' },
  { text: 'Purchase History', path: '/settings/purchase-history' },
  { text: 'Password', path: '/settings/password' },
  { text: 'Glowforge Printers', path: '/settings/printers' },
  { text: 'Users', path: '/settings/users' },
];

const SETTINGS_RESTRICTED_NAV_LINKS = [
  { text: 'General', path: '/settings/general' },
  { text: 'Password', path: '/settings/password' },
  { text: 'Glowforge Printers', path: '/settings/printers' },
];

const SettingsLeftNav = ({ features, isRestricted }) => {
  const accountLinks = isRestricted ? SETTINGS_RESTRICTED_NAV_LINKS : SETTINGS_UNRESTRICTED_NAV_LINKS;

  const enabledLinks = _.filter(accountLinks,
    link => !link.disabled || !link.disabled(features),
  );

  const links = _.map(enabledLinks, (link, index) => (
    <li key={index}>
      <Link
        className='clearLink'
        to={link.path}
        activeClassName='active'>
        {link.text}
      </Link>
    </li>
  ));

  return (
    <div className='SettingsLeftNav'>
      <ul>
        {links}
      </ul>
    </div>
  );
};

SettingsLeftNav.propTypes = {
  features: PropTypes.object, // eslint-disable-line
  isRestricted: PropTypes.bool,
};

SettingsLeftNav.defaultProps = {
  features: {},
  isRestricted: false,
};

export default settingsNav(SettingsLeftNav);



// WEBPACK FOOTER //
// ./app/components/settings/settings-left-nav.jsx